import useMediaQuery from '@eversports/klimt-design-components/use-media-query'
import useTheme from '@eversports/klimt-design-components/use-theme'
import Dialog, { DialogActions, DialogContent } from '@eversports/klimt-primitives/legacy/Dialog'

import NotificationPromotionActions from './NotificationPromotionActions'
import NotificationPromotionContent from './NotificationPromotionContent'

interface Props {
  isOpen: boolean
  toggleDialog: () => void
  userHandle: string
  friendsCount: number
}

const NotificationPromotionDialog = ({ isOpen, toggleDialog, userHandle, friendsCount }: Props) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const hasFriends = friendsCount > 0

  return (
    <Dialog open={isOpen} onClose={toggleDialog} fullScreen={isMobile} maxWidth="xs">
      <DialogContent sx={{ padding: 4, display: 'flex', alignItems: 'center' }}>
        <NotificationPromotionContent hasFriends={hasFriends} />
      </DialogContent>
      <DialogActions sx={{ padding: 4 }}>
        <NotificationPromotionActions userHandle={userHandle} hasFriends={hasFriends} onBackClick={toggleDialog} />
      </DialogActions>
    </Dialog>
  )
}

export default NotificationPromotionDialog
